<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      max-width="1000px"
      @input="onDialogClose"
    >
      <!-- Modal éxito -->
      <v-card v-if="event && event.type === 'qr_scan'" class="premium-card overflow-hidden">
        <v-toolbar dark color="primary">
          <v-icon large class="mr-3">local_parking</v-icon>
          <v-toolbar-title class="headline font-weight-bold">Invitación de Parking</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Chip de Tipo de Acceso -->
          <v-chip 
            v-if="invitationData && invitationData.access_type"
            :color="accessTypeColor"
            text-color="white"
            class="mr-2 font-weight-bold"
            label
          >
            <v-icon left>{{ accessTypeIcon }}</v-icon>
            {{ accessTypeLabel }}
          </v-chip>
          <v-chip v-if="countdown > 0" color="white" outline label class="mr-2">
            <v-icon left>timer</v-icon>{{ countdown }}s
          </v-chip>
          <v-btn color="white" flat icon @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text v-if="invitationData" class="pa-0">
          <!-- SECCIÓN DE ESTADO GENERAL - MUY VISIBLE -->
          <v-card flat color="blue-grey lighten-4" class="mx-4 mt-4 mb-4 pa-4 elevation-3" style="border-left: 6px solid #1976d2;">
            <v-layout row wrap align-center>
              <v-flex xs12 md3 class="text-xs-center text-md-left mb-3 mb-md-0">
                <div class="caption blue-grey--text mb-1">ESTADO GENERAL</div>
                <v-chip 
                  large
                  :color="getQRStatusColor"
                  text-color="white"
                  class="font-weight-bold"
                >
                  <v-icon left>{{ getQRStatusIcon }}</v-icon>
                  {{ getQRStatusLabel }}
                </v-chip>
              </v-flex>

              <v-flex xs12 md3 class="text-xs-center text-md-left mb-3 mb-md-0">
                <div class="caption blue-grey--text mb-1">DENTRO DE INSTALACIÓN</div>
                <v-chip 
                  large
                  :color="isInside ? 'success' : 'grey'"
                  text-color="white"
                  class="font-weight-bold"
                >
                  <v-icon left>{{ isInside ? 'check_circle' : 'radio_button_unchecked' }}</v-icon>
                  {{ isInside ? 'DENTRO' : 'FUERA' }}
                </v-chip>
              </v-flex>

              <v-flex xs12 md3 class="text-xs-center text-md-left mb-3 mb-md-0">
                <div class="caption blue-grey--text mb-1">VIGENCIA QR</div>
                <v-chip 
                  large
                  :color="isExpired ? 'error' : 'success'"
                  text-color="white"
                  class="font-weight-bold"
                >
                  <v-icon left>{{ isExpired ? 'schedule' : 'check_circle' }}</v-icon>
                  {{ isExpired ? 'VENCIDO' : 'VIGENTE' }}
                </v-chip>
              </v-flex>

              <v-flex xs12 md3 class="text-xs-center text-md-left">
                <div class="caption blue-grey--text mb-1">ESPACIO</div>
                <v-chip 
                  large
                  :color="hasAvailableSpace ? 'success' : 'warning'"
                  text-color="white"
                  class="font-weight-bold"
                >
                  <v-icon left>{{ hasAvailableSpace ? 'check_circle' : 'warning' }}</v-icon>
                  {{ hasAvailableSpace ? 'DISPONIBLE' : 'SIN ESPACIO' }}
                </v-chip>
              </v-flex>
            </v-layout>

          </v-card>

          <v-container grid-list-md>
            <v-layout row wrap>

              <!-- Sección Visitante -->
              <v-flex xs12 md6>
                <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                  <div v-if="invitationData.guest_avatar" class="d-flex align-center justify-center mb-3">
                    <v-avatar size="100" class="elevation-4">
                      <v-img :src="invitationData.guest_avatar"></v-img>
                    </v-avatar>
                  </div>
                  <h3 class="title primary--text text-xs-center mb-4">Información del Visitante</h3>

                  <v-list class="transparent" dense>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Visitante</v-list-tile-sub-title>
                        <v-list-tile-title class="font-weight-bold">{{ invitationData.guest_first_name }} {{ invitationData.guest_last_name }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="blue-grey">person</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.guest_phone">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Teléfono</v-list-tile-sub-title>
                        <v-list-tile-title>{{ invitationData.guest_phone }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="blue-grey">phone_iphone</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.guest_plates">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Placas</v-list-tile-sub-title>
                        <v-list-tile-title class="font-weight-bold">{{ invitationData.guest_plates }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="blue-grey">directions_car</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.guest_unit_specs">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Unidad</v-list-tile-sub-title>
                        <v-list-tile-title>{{ invitationData.guest_unit_specs }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="blue-grey">local_shipping</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.vehicle_type_name">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Tipo Vehículo</v-list-tile-sub-title>
                        <v-list-tile-title>{{ invitationData.vehicle_type_name }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="blue-grey">commute</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.subject">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Asunto</v-list-tile-sub-title>
                        <v-list-tile-title>{{ invitationData.subject }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="blue-grey">notes</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.invitation_date">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Vigencia</v-list-tile-sub-title>
                        <v-list-tile-title>{{ invitationData.invitation_date }} – {{ invitationData.expiration }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="primary">event</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.start_time">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Horario</v-list-tile-sub-title>
                        <v-list-tile-title>{{ invitationData.start_time }} – {{ invitationData.end_time }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="primary">schedule</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>

                  <!-- Identificación INE -->
                  <div v-if="invitationData.guest_id_front || invitationData.guest_id_back" class="mt-3">
                    <div class="caption blue-grey--text mb-2">Identificación</div>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 v-if="invitationData.guest_id_front" class="pr-1">
                        <div class="caption blue-grey--text mb-1">Frente</div>
                        <v-card flat class="ine-card mb-2">
                          <v-img :src="invitationData.guest_id_front" aspect-ratio="1.586" contain class="ine-img">
                            <template v-slot:placeholder>
                              <v-layout fill-height align-center justify-center>
                                <v-progress-circular indeterminate color="blue-grey"></v-progress-circular>
                              </v-layout>
                            </template>
                          </v-img>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="invitationData.guest_id_back" class="pl-1">
                        <div class="caption blue-grey--text mb-1">Reverso</div>
                        <v-card flat class="ine-card mb-2">
                          <v-img :src="invitationData.guest_id_back" aspect-ratio="1.586" contain class="ine-img">
                            <template v-slot:placeholder>
                              <v-layout fill-height align-center justify-center>
                                <v-progress-circular indeterminate color="blue-grey"></v-progress-circular>
                              </v-layout>
                            </template>
                          </v-img>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-card>
              </v-flex>

              <!-- Sección Anfitrión / Empresa -->
              <v-flex xs12 md6>
                <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                  <div v-if="invitationData.company_logo" class="d-flex align-center justify-center mb-3">
                    <v-img :src="invitationData.company_logo" max-width="120" max-height="120" contain class="elevation-2"></v-img>
                  </div>
                  <div v-else-if="invitationData.host_avatar" class="d-flex align-center justify-center mb-3">
                    <v-avatar size="100" class="elevation-4">
                      <v-img :src="invitationData.host_avatar"></v-img>
                    </v-avatar>
                  </div>

                  <h3 class="title primary--text text-xs-center mb-4">Información del Anfitrión</h3>

                  <v-list class="transparent" dense>
                    <v-list-tile v-if="invitationData.company_name">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Empresa</v-list-tile-sub-title>
                        <v-list-tile-title class="font-weight-bold">{{ invitationData.company_name }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="blue-grey">business</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Anfitrión</v-list-tile-sub-title>
                        <v-list-tile-title class="font-weight-bold">{{ invitationData.host_first_name }} {{ invitationData.host_last_name }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="blue-grey">person</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.host_phone">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Teléfono</v-list-tile-sub-title>
                        <v-list-tile-title>{{ invitationData.host_phone }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="blue-grey">phone_iphone</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.section_name">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Sección</v-list-tile-sub-title>
                        <v-list-tile-title>{{ invitationData.section_name }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="blue-grey">location_on</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.space_number" class="space-tile">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Espacio Asignado</v-list-tile-sub-title>
                        <v-list-tile-title class="font-weight-bold display-1 primary--text space-number">{{ invitationData.space_number }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="primary">local_parking</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.access_type">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Tipo de Acceso</v-list-tile-sub-title>
                        <v-list-tile-title>
                          <v-chip 
                            small
                            :color="accessTypeColor"
                            text-color="white"
                            class="font-weight-bold"
                          >
                            <v-icon left x-small>{{ accessTypeIcon }}</v-icon>
                            {{ accessTypeLabel }}
                          </v-chip>
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small :color="accessTypeColor">{{ accessTypeIcon }}</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-list-tile v-if="invitationData.notes">
                      <v-list-tile-content>
                        <v-list-tile-sub-title class="caption blue-grey--text">Notas</v-list-tile-sub-title>
                        <v-list-tile-title>{{ invitationData.notes }}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon small color="blue-grey">comment</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>

                  <!-- Chips de estado -->
                  <div class="mt-3">
                    <!-- Tipo de Acceso -->
                    <v-chip 
                      v-if="invitationData.access_type"
                      small
                      :color="accessTypeColor"
                      text-color="white"
                      class="mr-1 font-weight-bold"
                    >
                      <v-icon left small>{{ accessTypeIcon }}</v-icon>
                      {{ accessTypeLabel }}
                    </v-chip>
                    <v-chip v-if="invitationData.qr_status" small :color="invitationData.qr_status === 'active' ? 'success' : 'error'" text-color="white" class="mr-1">
                      {{ invitationData.qr_status }}
                    </v-chip>
                    <v-chip v-if="invitationData.arrival_registered" small color="blue" text-color="white" class="mr-1">
                      <v-icon left small>check</v-icon>Llegada registrada
                    </v-chip>
                    <v-chip v-if="invitationData.available_spaces && invitationData.available_spaces.length === 0" small color="orange" text-color="white">
                      <v-icon left small>warning</v-icon>Sin espacios
                    </v-chip>
                  </div>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <span class="caption grey--text">ID: {{ invitationData ? invitationData.id : '' }}</span>
          <v-spacer></v-spacer>
          <v-btn large depressed class="rounded-btn mx-2" color="primary" @click="closeModal">
            <v-icon left>close</v-icon>Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- Modal error -->
      <v-card v-else-if="event && event.type === 'qr_error'" class="premium-card overflow-hidden">
        <v-toolbar dark color="error">
          <v-icon large class="mr-3">error_outline</v-icon>
          <v-toolbar-title class="headline font-weight-bold">Error al procesar QR</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white" flat icon @click="closeModal"><v-icon>close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-list class="transparent" dense>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-sub-title class="caption blue-grey--text">Código QR</v-list-tile-sub-title>
                <v-list-tile-title class="font-weight-bold">{{ event.qr_code }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-sub-title class="caption blue-grey--text">Error</v-list-tile-sub-title>
                <v-list-tile-title class="error--text">{{ event.error }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="event.message">
              <v-list-tile-content>
                <v-list-tile-title class="caption grey--text">{{ event.message }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn large depressed class="rounded-btn mx-2" color="primary" @click="closeModal">
            <v-icon left>close</v-icon>Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  name: 'WebsocketEventModal',
  data() {
    return {
      countdown: 0,
      countdownTimer: null
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(['isWebsocketModalOpen', 'getWebsocketEvent']),
    dialog: {
      get() {
        return this.isWebsocketModalOpen
      },
      set(value) {
        if (!value) {
          this.SHOW_WEBSOCKET_MODAL(false)
        }
      }
    },
    event() {
      return this.getWebsocketEvent
    },
    invitationData() {
      return (this.event && this.event.data) || null
    },
    accessTypeLabel() {
      if (!this.invitationData || !this.invitationData.access_type) {
        return ''
      }
      const type = this.invitationData.access_type.toLowerCase()
      const labels = {
        'entry': 'ENTRADA',
        'exit': 'SALIDA',
        'in': 'ENTRADA',
        'out': 'SALIDA',
        'entrada': 'ENTRADA',
        'salida': 'SALIDA',
        'ingreso': 'INGRESO',
        'egreso': 'EGRESO'
      }
      return labels[type] || this.invitationData.access_type.toUpperCase()
    },
    accessTypeColor() {
      if (!this.invitationData || !this.invitationData.access_type) {
        return 'grey'
      }
      const type = this.invitationData.access_type.toLowerCase()
      if (type === 'entry' || type === 'in' || type === 'entrada' || type === 'ingreso') {
        return 'success' // Verde para entrada
      } else if (type === 'exit' || type === 'out' || type === 'salida' || type === 'egreso') {
        return 'warning' // Naranja para salida
      }
      return 'grey'
    },
    accessTypeIcon() {
      if (!this.invitationData || !this.invitationData.access_type) {
        return 'info'
      }
      const type = this.invitationData.access_type.toLowerCase()
      if (type === 'entry' || type === 'in' || type === 'entrada' || type === 'ingreso') {
        return 'arrow_downward' // Flecha hacia abajo para entrada
      } else if (type === 'exit' || type === 'out' || type === 'salida' || type === 'egreso') {
        return 'arrow_upward' // Flecha hacia arriba para salida
      }
      return 'info'
    },
    isInside() {
      // Verifica si el visitante está dentro basado en arrival_registered
      return this.invitationData && this.invitationData.arrival_registered === true
    },
    isExpired() {
      // Verifica si el QR está vencido
      if (!this.invitationData || !this.invitationData.expiration) {
        return false
      }
      const today = moment().startOf('day')
      const expiration = moment(this.invitationData.expiration).startOf('day')
      return expiration.isBefore(today)
    },
    daysRemaining() {
      if (!this.invitationData || !this.invitationData.expiration) {
        return null
      }
      const today = moment().startOf('day')
      const expiration = moment(this.invitationData.expiration).startOf('day')
      return expiration.diff(today, 'days')
    },
    daysRemainingText() {
      if (this.daysRemaining === null) {
        return null
      }
      if (this.daysRemaining < 0) {
        return 'Vencido'
      }
      if (this.daysRemaining === 0) {
        return 'Hoy'
      }
      return `${this.daysRemaining} días`
    },
    hasAvailableSpace() {
      // Verifica si hay espacios disponibles
      if (!this.invitationData) {
        return false
      }
      // Si available_spaces es un array
      if (Array.isArray(this.invitationData.available_spaces)) {
        return this.invitationData.available_spaces.length > 0
      }
      // Si es booleano directo
      return this.invitationData.available_spaces === true
    },
    getQRStatusColor() {
      if (!this.invitationData || !this.invitationData.qr_status) {
        return 'grey'
      }
      const status = this.invitationData.qr_status.toLowerCase()
      const colorMap = {
        'pending': 'grey',
        'active': 'success',
        'inactive': 'orange',
        'in_use': 'blue',
        'used': 'green',
        'expired': 'error'
      }
      return colorMap[status] || 'grey'
    },
    getQRStatusLabel() {
      if (!this.invitationData || !this.invitationData.qr_status) {
        return 'DESCONOCIDO'
      }
      const status = this.invitationData.qr_status.toLowerCase()
      const labelMap = {
        'pending': 'PENDIENTE',
        'active': 'ACTIVO',
        'inactive': 'INACTIVO',
        'in_use': 'EN USO',
        'used': 'USADO',
        'expired': 'EXPIRADO'
      }
      return labelMap[status] || this.invitationData.qr_status.toUpperCase()
    },
    getQRStatusIcon() {
      if (!this.invitationData || !this.invitationData.qr_status) {
        return 'help'
      }
      const status = this.invitationData.qr_status.toLowerCase()
      const iconMap = {
        'pending': 'schedule',
        'active': 'check_circle',
        'inactive': 'pause_circle_filled',
        'in_use': 'remove_circle_outline',
        'used': 'done_all',
        'expired': 'error'
      }
      return iconMap[status] || 'help'
    }
  },
  methods: {
    ...mapMutations(['SHOW_WEBSOCKET_MODAL']),
    closeModal() {
      this.stopCountdown()
      this.SHOW_WEBSOCKET_MODAL(false)
    },
    onDialogClose(value) {
      if (!value) {
        this.stopCountdown()
        this.SHOW_WEBSOCKET_MODAL(false)
      }
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A'
      try {
        const date = new Date(dateString)
        return date.toLocaleString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch {
        return dateString
      }
    },
    formatExpirationDate(dateString) {
      if (!dateString) return 'N/A'
      try {
        return moment(dateString).format('DD/MM/YYYY HH:mm')
      } catch {
        return dateString
      }
    },
    formatDateTime(dateString) {
      if (!dateString) return 'N/A'
      try {
        return moment(dateString).format('DD/MM/YYYY HH:mm:ss')
      } catch {
        return dateString
      }
    },
    startCountdown() {
      this.countdown = 30
      this.countdownTimer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.closeModal()
        }
      }, 1000)
    },
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdown = 0
      }
    }
  },
  watch: {
    'dialog': function(newVal) {
      if (newVal && this.event && this.event.type === 'qr_scan') {
        // Iniciar cuenta atrás solo para eventos de QR exitosos
        this.startCountdown()
      }
    }
  },
  beforeDestroy() {
    this.stopCountdown()
  }
}
</script>

<style scoped>
.premium-card {
  border-radius: 12px;
}

.rounded-card {
  border-radius: 10px;
}

.rounded-btn {
  border-radius: 8px;
}

.ine-card {
  border-radius: 6px;
  border: 1px solid #cfd8dc;
  overflow: hidden;
}

.ine-img {
  background-color: #eceff1;
}

.space-tile {
  height: auto !important;
  min-height: 72px !important;
}

.space-number {
  height: auto !important;
  white-space: normal !important;
  overflow: visible !important;
  line-height: 1.2 !important;
  padding: 4px 0 !important;
}

/* Estilos para el panel de estado general */
.status-panel {
  background: linear-gradient(135deg, #eceff1 0%, #cfd8dc 100%);
  border-radius: 8px;
  border-left: 6px solid #1976d2;
}

.status-chip {
  min-width: 140px;
  font-size: 14px;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.status-label {
  font-weight: 600;
  letter-spacing: 0.5px;
  font-size: 11px;
}

.status-value {
  font-size: 13px;
  font-weight: 500;
}
</style>
